const e=e=>{e.llTempImage=document.createElement("IMG")},l=e=>{delete e.llTempImage},m=e=>e.llTempImage;export{e as addTempImage,l as deleteTempImage,m as getTempImage};
